import React from 'react';
import PropTypes from 'prop-types';
import { Field, Button, Checkbox } from '@ontruck/orc';
import { isEmpty } from 'utils/types';
import { urls } from 'utils/auth';

import { Trans } from 'react-i18next';
import api from 'api';
import Link from 'components/styled/link';

import LoadSpinner from 'components/LoadSpinner';

class InvitationsForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isTokenValid: true,
      password: '',
      accepted_terms: false,
      commercial_communications_accepted: false,
      error: false,
      fetching: true,
      success: false,
      errorField: false,
    };
  }

  componentDidMount() {
    const { match } = this.props;
    if (match && match.params && match.params.userInvitationToken) {
      this.checkToken({ token: match.params.userInvitationToken });
    } else {
      this.setState({ isTokenValid: false });
    }
  }

  checkToken = async ({ token }) => {
    try {
      const {
        data: { expired },
      } = await api.get(`${urls.invitations}${token}/`);
      this.setState({ isTokenValid: !expired });
    } catch (err) {
      this.setState({ isTokenValid: false });
    } finally {
      this.setState({ fetching: false });
    }
  };

  handleSubmitRequest = async (e) => {
    const { password, accepted_terms, commercial_communications_accepted } =
      this.state;
    const { match, login } = this.props;
    const token = match && match.params && match.params.userInvitationToken;
    e.preventDefault();
    if (isEmpty(password)) {
      this.setState({ errorField: true });
      return;
    }
    try {
      const {
        data: { username },
      } = await api.put(`${urls.invitations}${token}/`, {
        password,
        accepted_terms: accepted_terms ? 'gdpr' : '',
        commercial_communications_accepted,
      });
      login({ username, password });
    } catch (err) {
      this.setState({ error: true });
    }
  };

  handleSubmitReset = async (e) => {
    e.preventDefault();
    const { match } = this.props;
    const token =
      (match && match.params && match.params.userInvitationToken) || '';
    try {
      await api.post(`${urls.invitations}`, {
        expired_token: token,
      });
      this.setState({ success: true });
    } catch (err) {
      this.setState({ error: true });
    }
  };

  setValue = (_, { name, value }) => {
    this.setState({ [name]: value, errorField: false });
  };

  render() {
    const { className, t, legalLinks } = this.props;
    const {
      error,
      password,
      isTokenValid,
      success,
      fetching,
      errorField,
      accepted_terms,
      commercial_communications_accepted,
    } = this.state;

    if (fetching) {
      return (
        <div className={className}>
          <LoadSpinner skin="standar" />
        </div>
      );
    }

    if (success) {
      return (
        <div className={className}>
          <h2 className="title success">
            {t(`SignupInvitationForm.title_success`)}
          </h2>
          <p>{t(`SignupInvitationForm.subtitle_success`)}</p>
          <p>{t(`SignupInvitationForm.text_success`)}</p>
        </div>
      );
    }

    if (!isTokenValid || error) {
      return (
        <div className={className}>
          <h2 className="title error">
            {t(`SignupInvitationForm.title_expired`)}
          </h2>
          <p>{t(`SignupInvitationForm.subtitle_expired`)}</p>
          <div className="submit-button">
            <Button
              id="submit"
              type="submit"
              size="L"
              text={t('SignupInvitationForm.btn_label_expired')}
              dataE2E="btn_label_expired"
              onClick={this.handleSubmitReset}
            />
          </div>
        </div>
      );
    }

    return (
      <div className={className}>
        <h2 className="title">{t(`SignupInvitationForm.title`)}</h2>
        <p>{t(`SignupInvitationForm.subtitle`)}</p>

        <form
          className={`form ${errorField && 'form-error'}`}
          onSubmit={this.handleSubmitRequest}
        >
          <div className="tax-data inspectlet-sensitive">
            <Field
              id="password"
              name="password"
              onChange={this.setValue}
              label={t('recover.password_label')}
              type="password"
              fullWidth
              value={password}
              dataE2E="recover_password"
            />
          </div>

          <div className="terms">
            <Checkbox
              name="accepted_terms"
              label={
                <Trans
                  t={t}
                  i18nKey="SignupInvitationForm.gdpr_checkbox_label_terms_policy"
                  components={[
                    <Link
                      size="L"
                      href={(legalLinks && legalLinks.privacy) || ''}
                      target="_blank"
                      text={t('SignupInvitationForm.gdpr_privacy_policy')}
                      className="summary-legal-link"
                    />,
                    <Link
                      size="L"
                      href={(legalLinks && legalLinks.terms) || ''}
                      target="_blank"
                      text={t('SignupInvitationForm.gdpr_terms_and_conditions')}
                      className="summary-legal-link"
                    />,
                  ]}
                />
              }
              size="L"
              onChange={this.setValue}
              checked={accepted_terms}
            />

            <Checkbox
              name="commercial_communications_accepted"
              label={t('SignupInvitationForm.gdpr_commercial_communication')}
              size="L"
              onChange={this.setValue}
              value={commercial_communications_accepted}
            />
          </div>

          <div className="submit-button">
            <Button
              disabled={!accepted_terms || isEmpty(password)}
              id="submit"
              type="submit"
              size="L"
              text={t('SignupInvitationForm.btn_label')}
              dataE2E="login_submit"
            />
          </div>
        </form>
      </div>
    );
  }
}

InvitationsForm.propTypes = {
  className: PropTypes.string.isRequired,
  match: PropTypes.shape({
    path: PropTypes.string,
  }),
  t: PropTypes.func,
  login: PropTypes.func,
  legalLinks: PropTypes.shape({
    terms: PropTypes.string,
    privacy: PropTypes.string,
  }).isRequired,
};

InvitationsForm.defaultProps = {
  t: (t) => t,
  match: {},
  login: () => ({}),
};

export default InvitationsForm;
